export default __webpack_public_path__ + "static/media/joytcp-5.94898192.png";